module.exports = __webpack_public_path__ + "static/media/level-4-19.7635fe48.svg";